<template>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h1>test</h1>
  <div v-html="teststr">

  </div>


</template>

<script>
import {onMounted} from 'vue'


export default {
  name: "test",
  components: {onMounted,},
  setup() {
    let teststr = "<h1>test h1</h1> <img src='http://161.117.189.36/media/employee/tim.jpg' style='width: 20vw'>"
    return {teststr}
  }
}
</script>
